export { default } from './VideoThumbnail.component';
